<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-indicator-type-b-html">
      <div class="two-col-wrapper">
        <div
          class="col-inner background-grey-soft inner-padding rounded-corners-10"
        >
          <h4>Highlights</h4>
          <div class="highlights" v-html="cwaData.Highlights"></div>

          <div v-if="cwaData.ForecastTable" class="pt-5">
            <h4>{{ cwaData.ForecastTable.TableHeader }}</h4>
            <div
              v-if="cwaData.ForecastTable.RowData.length > 0"
              class="table-responsive"
            >
              <table class="tr-data-table darker-borders">
                <tbody>
                  <tr
                    v-for="(value, index) in cwaData.ForecastTable.RowData"
                    :key="index"
                  >
                    <td
                      class="table-td"
                      v-for="(data, dataIndex) in value"
                      :key="dataIndex"
                      :style="getStyle(index, 'ForecastTable')"
                    >
                      {{
                        data === '' && (dataIndex !== 0 || index !== 0)
                          ? 'N/A'
                          : data
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="cwaData.ShowForecastRange" class="pt-5">
            <h4>{{ cwaData.ForecastRangeTable.TableHeader }}</h4>
            <div
              v-if="cwaData.ForecastRangeTable.RowData.length > 0"
              class="table-responsive"
            >
              <table class="tr-data-table darker-borders">
                <tbody>
                  <tr
                    v-for="(value, index) in cwaData.ForecastRangeTable.RowData"
                    :key="index"
                  >
                    <td
                      class="table-td__foreacast"
                      v-for="(data, dataIndex) in value"
                      :key="dataIndex"
                      :style="getStyle(index, 'ForecastRangeTable')"
                    >
                      {{ data === '' ? ' N/A' : addSpaceToData(data) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="pt-5">
            <h4>Overview</h4>
            <div class="overview" v-html="cwaData.Overview"></div>
          </div>
        </div>
        <div class="col-inner inner-padding-top">
          <div>
            <h4>Rate-of-Change</h4>
            <TrendsReportROCChart :rocData="this.cwaData.RoCChart" />
            <br />
          </div>
          <div>
            <h4>Data Trend</h4>
            <TrendsReportDTChart
              v-if="cwaData.DataTrendsChart"
              :dtData="cwaData.DataTrendsChart"
            />
          </div>
          <div class="tr-phase-box" v-bind:class="phaseClass" v-if="phaseClass">
            <div class="tr-phase-box--left">
              <img
                :src="imagespath + '/images/tr-' + phaseClass + '.png'"
                alt="Trends Report Phase Logo"
              />
            </div>
            <div class="tr-phase-box--right">
              <h4>ITR Management Objective</h4>
              <div
                class="management-objective"
                v-html="cwaData.ManagementObjectives"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import TrendsReportROCChart from '~/components/trendsreport/TrendsReportROCChart.vue';
  import TrendsReportDTChart from '~/components/trendsreport/TrendsReportDTChart.vue';

  export default {
    name: 'IndicatorTypeBTemplate',
    props: {
      cwaData: {
        type: Object,
        required: true,
      },
      imagespath: {
        type: String,
        required: true,
      },
    },
    components: {
      TrendsReportROCChart,
      TrendsReportDTChart,
    },
    computed: {
      phaseClass() {
        if (this.cwaData.Phase === 'A') {
          return 'phase-a';
        } else if (this.cwaData.Phase === 'B') {
          return 'phase-b';
        } else if (this.cwaData.Phase === 'C') {
          return 'phase-c';
        } else if (this.cwaData.Phase === 'D') {
          return 'phase-d';
        } else {
          return null;
        }
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      getStyle(index, tableType) {
        if (index !== 0) return '';
        if (tableType === 'ForecastTable') {
          if (index === 0 && this.cwaData.ForecastTable.RowData[0].length > 2) {
            return 'font-weight:bold';
          }
        }
        if (tableType === 'ForecastRangeTable') {
          if (
            index === 0 &&
            this.cwaData.ForecastRangeTable.RowData[0].length > 2
          ) {
            return 'font-weight:bold';
          }
        }
      },
      addSpaceToData(data) {
        let spacedData = data
          .split(' ')
          .map((item) => ` ${item} `)
          .join('');
        return spacedData;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .table-td {
    width: 10%;
    &__foreacast {
      white-space: pre !important;
    }
  }
  .highlights,
  .overview {
    * {
      font-size: 17px !important;
      color: var(--itr-charcoal) !important;
      background-color: transparent !important;
      font-family: 'Open Sans', sans-serif !important;
    }
  }
  .management-objective {
    * {
      font-size: 17px !important;
      color: var(--itr-white) !important;
      background-color: transparent !important;
      font-family: 'Open Sans', sans-serif !important;
    }
  }
</style>
